import { SvgProps } from "./types"

export const MusdCampaignIcon = ({ width = "32", height = "32" }: SvgProps) => (
  <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5484_39192)">
      <rect width="32" height="32" rx="8" ry="8" fill="#EAEEEA" />
      <path d="M17.2842 4.42822L24.9987 12.1428H17.2842V4.42822Z" fill="#147552" />
      <path d="M17.2842 12.1428L24.9987 19.8574H17.2842V12.1428Z" fill="#48D99C" />
      <path d="M17.2842 27.5719L24.9987 19.8574H17.2842V27.5719Z" fill="#147552" />
      <path d="M14.7148 4.42822L7.00029 12.1428H14.7148V4.42822Z" fill="#48D99C" />
      <path d="M14.7148 19.8573L7.0003 12.1428H14.7148V19.8573Z" fill="#147552" />
      <path d="M14.7148 27.5719L7.00029 19.8574H14.7148V27.5719Z" fill="#48D99C" />
    </g>
    <defs>
      <clipPath id="clip0_5484_39192">
        <rect width={width} height={height} fill="white" />
      </clipPath>
    </defs>
  </svg>
)
